<template>
  <div :class="['dept', isFold ? 'fold-dept' : 'left-dept']">
    <div class="now-name" v-show="!isFold">
      {{ nowName }}
    </div>
    <div :class="['deal-fold', collapse ? 'left-46' : 'left-200']" @click="handleFold">
      <img :src="!isFold ? iconShouqi : iconZhankai" alt="" class="fold-icon" />
      <span v-show="!isFold">收起</span>
      <span v-show="isFold">展开</span>
    </div>
    <el-input
      class="search-dept"
      v-model.trim="departmentName"
      @change="searchDep"
      size="small"
      placeholder="请输入部门名称"
      v-show="!isFold"
      prefix-icon="el-icon-search"
    />
    <el-tree
      v-show="!isFold"
      class="tree-dept"
      ref="tree"
      node-key="uuid"
      :props="props"
      :data="deptTreeList"
      lazy
      :load="loadNode"
      @node-click="nodeClick"
      :filter-node-method="filterNode"
    >
    <span class="custom-tree-node" slot-scope="{ node, data }">
        <el-tooltip v-if="isSearch" class="item" effect="dark" :content="data.fullName" placement="top-start">
          <span class="ellipsis--l1">{{ data.simpleName ||  node.label }}</span>
        </el-tooltip>
        <el-tooltip v-else class="item" effect="dark" :content="node.label" placement="top-start">
          <span class="ellipsis--l1">{{ node.label }}</span>
        </el-tooltip>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getItem, setItem } from "@/utils/storage";
import { lazyTree } from "@/api/dept";
import { iconShouqi, iconZhankai } from "@/assets/image/icon-set/index.js";

export default {
  computed: mapState({
    collapse: (state) => state.app.collapse,
  }),
  props: {
    defaultId: {
      type: String,
      default: "",
    },
    defaultExpandKeys: {
      type: Array,
      required: true,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      iconShouqi,
      deptTreeList: [],
      iconZhankai,
      props: {
        label: "name",
        // children: "children",
        isLeaf: "isLeaf",
      },
      departmentName: "",
      isFold: false,
      nowName: getItem("topDeptName"),
      isSearch: false,
    };
  },
  watch: {
    defaultId: {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(val);
        });
      },
    },
  },
  updated() {
    let doms = document.getElementsByClassName("el-tree-node__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve(this.deptTreeList);
      }
      if (node.level >= 1) return this.getChildNode(node, resolve);
    },
    getChildNode(node, resolve) {
      setTimeout(() => {
        lazyTree({
          parentId: node.data.id,
        }).then((res) => {
          res.data.map((v) => {
            if (v && v.hasChildren == 0) {
              v.isLeaf = true;
            } else {
              v.isLeaf = false;
            }
            resolve(res.data);
          });
        });
      }, 300);
    },

    handleFold() {
      this.isFold = !this.isFold;
    },
    nodeClick(data) {
      let { id, name } = data;
      this.nowName = name;
      // console.log(data, "{ id, name }");
      setItem("selectTreeId", id);
      this.$emit("select", { id, name });
    },
    spanNodeClick(data) {
      console.log('----11111----', data);
      
    },
    searchDep(val) {
      // this.$refs.tree.filter(val);
      this.deptTreeList = [];
      this.isSearch = val && val.length > 0

      lazyTree({ deptName: val }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.map((v) => {
            if (v.hasChildren == 0) {
              v.isLeaf = true;
            }
          });
          this.deptTreeList = res.data;
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.now-name {
  font-size: 14px;
  font-weight: 600;
  color: #343c4a;
  width: 205px;
  line-height: 20px;
  margin-top: -12px;
  padding-bottom: 5px;
  padding-top: 12px;
}
.dept {
  border-right: 1px solid #d9dde2;
  position: relative;
  margin-right: 16px;
  height: calc(100vh - 97px);
  .search-dept {
    font-size: 12px;
  }
  /deep/ .el-input__inner::placeholder {
    font-size: 12px;
  }
  .tree-dept {
    margin-top: 10px;
    color: #51627d;
    font-size: 12px;
  }
}
.left-dept {
  width: 206px;
  margin-top: -12px;
  padding: 12px 12px 0 0;
  box-sizing: border-box;
  transition: all 0.3s;
  overflow-x: auto;
  overflow-y: auto;
  /deep/ .el-tree-node__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.left-46 {
  left: 46px;
}
.left-200 {
  left: 200px;
}
.deal-fold {
  text-align: right;
  margin-bottom: 10px;
  position: fixed;
  // right: -16px;
  top: 333px;
  cursor: pointer;
  width: 16px;
  height: 60px;
  background: #d9dde2;
  box-shadow: 1px 0px 6px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0px 4px 4px 0px;
  font-size: 12px;
  text-align: center;
  z-index: 999;
}
.fold-dept {
  width: 0px;
  transition: all 0.3s;
  margin-left: -12px;
}
.fold-icon {
  width: 12px;
  height: 12px;
  margin-top: 9px;
}
</style>
